import { IIconProps } from "../types"

export default function IconLL2(props: IIconProps) {
  const width = props.size || props.width || 52
  const height = props.size || props.height || 87
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 52 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.5312 7.97249C50.3312 5.75249 49.6212 4.58249 47.9212 3.60249C46.2312 2.63249 43.5612 1.84249 38.4512 1.29249C33.3412 0.742486 25.7912 0.412486 20.2912 0.452486C14.7912 0.482486 11.3412 0.872486 8.73122 1.65249C6.13122 2.43249 4.37122 3.60249 3.16122 5.65249C1.96122 7.70249 1.31122 10.6325 0.891224 14.9325C0.461224 19.2325 0.271224 24.8925 0.661224 35.3425C1.05122 45.7925 2.02122 61.0325 3.26122 69.9825C4.50122 78.9325 6.00122 81.6025 8.14122 83.3225C10.2912 85.0525 13.0912 85.8325 16.3812 86.1625C19.6712 86.4825 23.4412 86.3525 26.3712 85.5425C29.3012 84.7225 31.3912 83.2325 33.1812 81.0825C34.9712 78.9325 36.4712 76.1325 38.5512 69.5525C40.6312 62.9825 43.3012 52.6325 45.3212 43.1925C47.3412 33.7525 48.7112 25.2225 49.5512 19.3325C50.4012 13.4325 50.7212 10.1825 50.5312 7.97249Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.9"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
